import styled from 'styled-components';
import { SearchLocation } from '@lt/components/icons-react/userflow';

export const LocationIcon = styled(SearchLocation)`
  width: 16px;
  height: 16px;
`;
